import { apiRequest } from './client';

/** Public links the marketing site shows, and the master admin's control of them (Admin > Branding). */
const PUBLIC = '/api/v1/site-links';
const ADMIN = '/api/v1/admin/site-links';
const TOKEN_KEY = 'policyora_token';

function authOpts(extra: RequestInit = {}): RequestInit {
  const token = localStorage.getItem(TOKEN_KEY);
  return { ...extra, headers: { 'Content-Type': 'application/json', ...(token ? { Authorization: `Bearer ${token}` } : {}), ...(extra.headers ?? {}) } };
}

export interface SiteLinks {
  /** Empty means the booking buttons are hidden. */
  demo_booking_url: string;
}

export interface AdminSiteLinks extends SiteLinks {
  default_demo_booking_url: string;
  max_length: number;
}

export const fetchSiteLinks = () => apiRequest<SiteLinks>(PUBLIC, { method: 'GET' });
export const adminSiteLinks = () => apiRequest<AdminSiteLinks>(ADMIN, authOpts());
export const adminUpdateSiteLinks = (demoBookingUrl: string) =>
  apiRequest<SiteLinks>(ADMIN, authOpts({ method: 'PUT', body: JSON.stringify({ demo_booking_url: demoBookingUrl }) }));
